import _ from 'underscore';
import classNames from 'classnames';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from '@fluentui/react-components';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { duration2Input, input2Duration } from '@bingads-webui-campaign-react/auto-goal-creation-wizard-utils';
import { ValidationGroup } from '@bingads-webui-react/primitive-validation-fluent';

import { getGoalDetailFormStyles } from '../styles/goal-details-setting-form-style';
import { ValidatedInput, errorMessageMapping, handleValidationMessages } from '../control-components/validated-helper';
import { autoGoalSettingSchema } from '../auto-goal-schema';

export const ConversionWindowFormUnstyled = ({
  i18n,
  className,
  classes,
  onChange,
  windowTargetName,
  schemaFieldGroupName,
  conversionWindowInMin,
  label,
  maxWindowInMin,
  minWindowInMin,
}) => {
  const timeObj = duration2Input(conversionWindowInMin);
  const maxWindowInDay = maxWindowInMin / 24 / 60;
  const customError = [i18n.getString(_TL_('Enter a conversion period of up to {{day}} days.'), { day: maxWindowInDay })];
  const customValidator = total => total >= minWindowInMin && total <= maxWindowInMin;
  const [showError, setShowError] = useState(false);
  const onValidate = (result) => {
    if (result && result.isValid) {
      const updateObj = { ...timeObj, ..._.get(result, ['data', schemaFieldGroupName]) };
      const updatedTime = input2Duration(updateObj);
      if (customValidator(updatedTime)) {
        onChange(windowTargetName, updatedTime);
        setShowError(false);
      } else {
        setShowError(true);
      }
    }
  };
  const customErrorMapping = {
    ...errorMessageMapping,
    decimalLength: _TL_('Field requires integer value'),
  };

  const errorProcessor = errors => handleValidationMessages(i18n, errors, customErrorMapping);
  return (
    <Field label={label} hint={!showError && customError[0]} validationMessage={showError && customError}>
      <ValidationGroup
        validationProps={{
          schema: autoGoalSettingSchema,
          data: { [schemaFieldGroupName]: timeObj },
          onValidate,
    }}
      >
        <div className={classNames(className, classes.rowContainer)}>
          <div>
            <ValidatedInput
              fieldProps={{
                className: 'goal-day-input',
                label: i18n.getString(_TL_('Day')),
              }}
              i18n={i18n}
              size="small"
              validationProps={{
                field: `${schemaFieldGroupName}/Day`,
                errorProcessor,
                debounce: 700,
              }}
            />
          </div>
          <div>
            <ValidatedInput
              fieldProps={{
                className: 'goal-hour-input',
                label: i18n.getString(_TL_('Hour')),
              }}
              i18n={i18n}
              size="small"
              validationProps={{
                field: `${schemaFieldGroupName}/Hour`,
                errorProcessor,
                debounce: 700,
              }}
            />
          </div>
          <div>
            <ValidatedInput
              fieldProps={{
                className: 'goal-min-input',
                label: i18n.getString(_TL_('Minute')),
              }}
              i18n={i18n}
              size="small"
              validationProps={{
                field: `${schemaFieldGroupName}/Min`,
                errorProcessor,
                debounce: 700,
              }}
            />
          </div>
        </div>
      </ValidationGroup>
    </Field>
  );
};

ConversionWindowFormUnstyled.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape(_.mapObject(
    getGoalDetailFormStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  onChange: PropTypes.func.isRequired,
  windowTargetName: PropTypes.string.isRequired,
  schemaFieldGroupName: PropTypes.string.isRequired,
  conversionWindowInMin: PropTypes.number,
  maxWindowInMin: PropTypes.number.isRequired,
  minWindowInMin: PropTypes.number,
  label: PropTypes.node.isRequired,
};

ConversionWindowFormUnstyled.defaultProps = {
  className: 'goal-window-form',
  conversionWindowInMin: 0,
  minWindowInMin: 0,
};

export const ConversionWindowForm = withDefaultStyles(ConversionWindowFormUnstyled, getGoalDetailFormStyles);
